export default "__VITE_ASSET__CtMQtw07__"